import {makeAutoObservable} from "mobx";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {langTypes} from "../common/enums/ExcelEnum";

const logPrefix  = "[OddStepSevenStore]"
export default class OddStepSevenStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.audio = null;
        this.contentList = null;
        this.originalContentList = null;
        this.tempContentList = null;
        this.image = '';
        this.selectedContent = '';
        this.contentTapIndex = 0;
        this.isProcessing = false;
        this.isPositionProcessing = false;
        this.popoverState = false;
        this.positionPopoverState = false;
        this.timeoutId = 0;

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    init = () => {
        this.isProcessing = false;
        this.isPositionProcessing = false;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.init();
    };

    setIsProcessing = (isProcessing) => {
        this.isProcessing = isProcessing;
    }

    setIsPositionProcessing = (isProcessing) => {
        this.isPositionProcessing = isProcessing;
    }

    isChangeContent = () => {
        return JSON.stringify(this.originalContentList) !== JSON.stringify(this.contentList);
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = () => {
        return this.contentList.find(content => content.languageCode === langTypes[this.contentTapIndex]);
    }

    getSelectedOriginalContent = () => {
        return this.originalContentList.find(content => content.languageCode === langTypes[this.contentTapIndex]);
    }

    getContent = (index) => {
        return this.contentList.find(content => content.languageCode === langTypes[index]);
    }

    getSelectedTempContent = () => {
        return this.tempContentList.find(content => content.languageCode === langTypes[this.contentTapIndex]);
    }

    resetPosition = () => {
        const selectedTempContent = this.getSelectedTempContent();
        for (const piece of selectedTempContent.pieces) {
            piece.imageSequence = null;
        }
    }

    getTempContent = (index) => {
        return this.tempContentList.find(content => content.languageCode === langTypes[index]);
    }

    resetTempContentList = () => {
        this.tempContentList = JSON.parse(JSON.stringify(this.contentList));
    }

    sortPieceList = (pieceList) => {
        pieceList.sort((a,b) => a.textStartIndex - b.textStartIndex);
    }

    addPiece = (pieceList, piece) => {
        pieceList.push(piece);
    }

    removePiece = (pieceList, index) => {
        pieceList.splice(index, 1);
    }

    setPieceTextIndex = (piece, textStartIndex, textEndIndex) => {
        piece.textStartIndex = textStartIndex;
        piece.textEndIndex = textEndIndex;
    }

    setPieceImageSeq = (piece, seq) => {
        piece.imageSequence = seq;
    }

    setRandomPosition = () => {
        const selectedTempContent = this.getSelectedTempContent();

        const imageSeq = [];
        for (const piece of selectedTempContent.pieces) {
            while (true) {
                const randomNumber = Math.floor(Math.random() * 9) + 1;

                if (!imageSeq.some(seq => seq === randomNumber)) {
                    imageSeq.push(randomNumber);

                    piece.imageSequence = randomNumber;
                    break;
                }
            }
        }
    }

    setSubContentAudios = (audioRegionList) => {
        if (audioRegionList.length > 0) {

            const content = this.getSelectedContent();
            for (const piece of content.pieces) {
                piece.audioStartTime = null;
                piece.audioEndTime = null;
            }

            for (let i = 0; i < audioRegionList.length; i++) {
                let startTime = audioRegionList[i].start;
                let endTime = audioRegionList[i].end;

                const piece = content.pieces[i];
                piece.audioStartTime = startTime;
                piece.audioEndTime = endTime;
            }
        }
    }

    playAudio = (id, startTime, endTime) => {
        if (this.timeoutId !== 0) {
            clearTimeout(this.timeoutId);
        }
        if (this.audio && this.audio.id === id && !this.audio.paused) {
            this.stopAudio();
        } else {
            if (this.audio) {
                this.stopAudio();
            }
            const decodeAudio = atob(this.getSelectedContent().audio);
            const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], { type: 'audio/mp3' });

            this.audio = new Audio();
            this.audio.id = id;
            this.audio.src = URL.createObjectURL(blob);

            if (startTime !== undefined && endTime !== undefined) {
                const duration = (endTime - startTime) * 1000;
                this.audio.currentTime = startTime;

                this.audio.play();
                this.timeoutId = setTimeout(() => {
                    if (this.audio) {
                        this.stopAudio();
                    }
                }, duration);
            } else {
                this.audio.play();
            }
        }
    }


    playPieceAudio = (pieceAudio) => {
        if (this.audio) {
            this.stopAudio();
        }

        const decodeAudio = atob(pieceAudio);
        const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], { type: 'audio/mp3' });

        this.audio = new Audio();
        this.audio.src = URL.createObjectURL(blob);

        this.audio.play();
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    setPopoverState = (boolean) => {
        if (this.popoverState !== null) {
            this.popoverState = boolean;
        }
    }

    setPositionPopoverState = (boolean) => {
        if (this.positionPopoverState !== null) {
            this.positionPopoverState = boolean;
        }
    }

    savePieceListTextIndex = () => {
        const content = this.getContent(this.contentTapIndex);
        const tempContent = this.getTempContent(this.contentTapIndex);

        let isChange = false;
        if (content.pieces.length === tempContent.pieces.length) {
            for (let i = 0; i < content.pieces.length; i++) {
                if (content.pieces[i].textStartIndex !== tempContent.pieces[i].textStartIndex || content.pieces[i].textEndIndex !== tempContent.pieces[i].textEndIndex) {
                    isChange = true;
                    break;
                }
            }
        } else {
            isChange = true;
        }

        if (isChange) {
            content.pieces = [];
            for (const tempPiece of tempContent.pieces) {
                tempPiece.imageSequence = null;
                tempPiece.audioStartTime = null;
                tempPiece.audioEndTime = null;
                content.pieces.push(tempPiece);
            }
        }
    }

    savePieceListPosition = () => {
        const tempContent = this.getTempContent(this.contentTapIndex);

        for (let i = 0; i < this.contentList.length; i++) {
            const content = this.getContent(i);

            let isChange = false;
            if (content.pieces.length === tempContent.pieces.length) {
                for (let j = 0; j < content.pieces.length; j++) {
                    if (content.pieces[j].imageSequence !== tempContent.pieces[j].imageSequence) {
                        isChange = true;
                        break;
                    }
                }
            } else {
                isChange = true;
            }

            if (isChange) {
                for (let k = 0; k < tempContent.pieces.length; k++) {
                    if (content.pieces[k]) {
                        content.pieces[k].imageSequence = tempContent.pieces[k].imageSequence;
                    }
                }
            }
        }
    }

    getDividedText = (start, end) => {
        return this.getContent(this.contentTapIndex).text.slice(start, end);
    }

    * getOddStepSevenContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepSevenContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/7`;
            const response = yield this.contentRepository.getContent(url);

            this.image = response.data.image;
            this.contentList = response.data.contents;
            for (const content of this.contentList) {
                this.sortPieceList(content.pieces);
            }

            this.originalContentList = JSON.parse(JSON.stringify(this.contentList));
            this.tempContentList = JSON.parse(JSON.stringify(this.contentList));

            console.log(logPrefix, 'Finished getOddStepSevenContent.');
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepSevenContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepSevenContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepSevenContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/7`;
            const response = yield this.contentRepository.putContent(url, this.contentList);
            console.log(logPrefix, 'Finished modifyOddStepSevenContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepSevenContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    * getPieceAudio(piece, callback) {
        try {
            console.log(logPrefix, 'Start getPieceAudio.');
            const filePath = piece.audioFilePath + '/' + piece.audioFileName;
            const response = yield this.contentRepository.getAudio(filePath);
            piece.audio = response.data;

            console.log(logPrefix, 'Finished getPieceAudio : ', response);
            callback && callback(piece.audio);
        } catch (e) {
            console.log(logPrefix, 'Failed getPieceAudio.');
        }
    }

    isOddStepSevenCompleted = (data) => {
        if (data.contents.length < 4) {
            return false;
        }

        for (const content of data.contents) {
            if (content.pieces.length === 0) {
                return false;
            } else {
                for (const piece of content.pieces) {
                    if (piece.imageSequence === null || ((piece.audioStartTime === null || piece.audioEndTime == null) && (piece.audioFileName == null || piece.audioFilePath === null))) {
                        return false;
                    }
                }
            }
        }

        return true;
    }
}

